import { useSettings } from '@capsicum/common';
import { useDAppsRiskWarningActionGuard, useRouter } from '@capsicum/common-web';
import { usePartners } from '@capsicum/socios-core';
import { useCallback } from 'react';

export const useNCWPartnerRouting = () => {
	const { push } = useRouter();
	const { getPartnerBy } = usePartners();
	const triggerDAppsRiskWarningGuardedAction = useDAppsRiskWarningActionGuard();

	const {
		settings: { stakePepperLink }
	} = useSettings();

	const routeToPartnerPage = useCallback(
		(currencyId?: string) => {
			const partnerId = getPartnerBy(p => p.currencyId === currencyId)?.id;

			if (!partnerId) return;

			push(`/partner/${partnerId}`);
		},
		[push, getPartnerBy]
	);

	const routeToNcwPartnerDetail = useCallback(
		(tokenShortCode: string) => push(`/nc-wallet/partner-details/${tokenShortCode}`),
		[push]
	);

	const routeToPepperStaking = useCallback(() => {
		triggerDAppsRiskWarningGuardedAction(() => window.open(stakePepperLink, '_blank'));
	}, [stakePepperLink, triggerDAppsRiskWarningGuardedAction]);

	return {
		routeToNcwPartnerDetail,
		routeToPartnerPage,
		routeToPepperStaking
	};
};
